// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"06dde7e3","68":"7281837e","113":"806aa1a2","239":"9c648638","292":"58b12f0b","388":"bf3052c6","419":"4aa9b512","449":"76275dcd","526":"15c8699d","652":"dfb5422a"}[chunkId] + ".chunk.js";
};